export default __webpack_public_path__ + "static/media/SIDDANAGOUDA.3df8c859.JPG";